<template>
  <div class="lesson-content">
    <h1 class="lesson-title">Unit {{ content.order }}: {{ content.name }}</h1>
    <h3 class="lesson-subtitle">Introduction</h3>
    <nav class="panel"  v-if="selectedElement === null">
        <a @click="() => selectElement(part.id)" :class="'panel-block ' + (selectedElement === part.id ? 'is-active' : '')" v-bind:key="index" v-for="(part, index) in parts">{{ part.title }}</a>
    </nav>
    <h3 v-if="selectedPart !== null" class="lesson-subtitle2">{{ selectedPart.title }} <Button v-if="selectedElement !== null" :onClick="() => selectElement(null)" type="primary" size="medium">CLOSE</Button></h3>
    <div>
        <div v-if="selectedElement !== null" class="lesson-html" v-html="content[selectedElement]"></div>
        <Button v-if="selectedElement !== null" :onClick="() => selectElement(null)" type="primary" size="medium">CLOSE</Button>
    </div>
  </div>
</template>

<script>
import Button from '@/components/Button'

export default {
  components: {
    Button
  },
  props: {
    content: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      selectedElement: null,
      parts: [
        { id: 'play', title: 'Exploration Areas for Free Play' },
        { id: 'story', title: 'Storytime Suggestions' },
        { id: 'circle', title: 'Circle Time Movement Activities' },
        { id: 'songs', title: 'Circle Time Songs' }]
    }
  },
  watch: {
    $route (to, from) {
      this.selectedElement = null
    }
  },
  computed: {
    selectedPart: function () {
      if (this.selectedElement === null) {
        return null
      } else {
        return this.parts.filter(part => part.id === this.selectedElement)[0]
      }
    }
  },
  methods: {
    selectElement (element) {
      this.selectedElement = element
    }
  }
}
</script>

<style lang="scss">

@import '~styles/base/variables';
@import '~styles/base/mixins';
.panel-block.is-active {
    border-left-color: #e31c79;
}
.lesson-content {
  font-family: 'Brandon', serif;
  @include text-size-l();
  color: $color-text-dark;
}

.lesson-title {
  margin-bottom: 1.2rem;
  text-transform: uppercase;
  @include text-size-xxxl();
  font-weight: $font-weight-bold;
}
.lesson-subtitle {
  margin-bottom: 2rem;
  text-transform: uppercase;
  @include text-size-xxl();
  font-weight: $font-weight-bold;
}
.lesson-subtitle2 {
  margin-bottom: 2rem;
  text-transform: uppercase;
  position: relative;
  padding-right: 120px;
  box-sizing: border-box;
  @include text-size-l();
  font-weight: $font-weight-bold;
  .button {
    position: absolute;
    top: -7px;
    right: 0px;
  }

}
.complementaryInfo {
  display:block;
}
.panel {
    a {
        position: relative;
        padding: 1.2rem;
        cursor: pointer;
        font-size: 1.25rem;
        line-height: 1.5rem;
        color: #221c35;
        font-weight: normal;
        &:after {
            position: absolute;
            content: "\25B6";
            top: 50%;
            right: 1.5rem;
            transform: translateY(-50%);
            font-size: 1rem;
        }
    }
}
.lesson-html {

  h1 {
    margin-bottom: 2rem;
  }

  p {
    margin-bottom: 0.5rem;
  }

  h3 {
    color: #e31c79;
  }

  a{
    color: #3273dc;
  }

  ul {
    list-style-type: initial;
  }

  ul,
  ol {
    margin-left: 10px;

    li {
      display: list-item;
    }
  }
}

.social-block,
.orientation-block {
  font-family: 'Averta', $system-fonts;

  h3 {
    font-size: 1.1rem;
    font-weight: bolder;
    color: #0a2239;
  }

  p {
    font-size: 1rem;
    line-height: 1.2rem;
    color: #6B7285;
  }

  a {
    font-size: 0.9rem;
    font-weight: bolder;
    color: #E31C79;
  }
}

.social-block {
  padding: 1rem 0 2rem 0;
}

.orientation-block {
  padding-bottom: 2rem;

  .box {
    border-radius: 0;
    box-shadow: none;
    border: 1px solid #c4c7ce;
    padding: 1rem;
    margin-bottom: 0.6rem;
  }

  h3 {
    margin-bottom: 1rem;
  }

  p {
    margin-bottom: 0 !important;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/UnitContent.vue